import { render, staticRenderFns } from "./Selling.vue?vue&type=template&id=0cc9c328&scoped=true&"
import script from "./Selling.vue?vue&type=script&lang=ts&"
export * from "./Selling.vue?vue&type=script&lang=ts&"
import style0 from "./Selling.vue?vue&type=style&index=0&id=0cc9c328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9c328",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VImg})
